/**
 * The names of layout algorithms that can be used with the Benchling ReactFlow library.
 */
export enum LayoutAlgorithmName {
  DAGRE = 'dagre',
  ELK = 'elk',
}

/**
 * The default layout algorithm used in the Benchling ReactFlow library.
 */
export const DEFAULT_LAYOUT_ALGORITHM = LayoutAlgorithmName.DAGRE;
